<script lang="ts">
      import { untrack } from 'svelte'
      import ImageElement from '../gallery/ImageElement.svelte'
      import Gafa from '../hero/ui/Gafa.svelte'
      import LexicalRender from '../lexical/LexicalRender.svelte'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'
      import Metatags from '../metatags/Metatags.svelte'
      import QuoteBlock from '../quote/QuoteBlock.svelte'
      import Button from '../ui/Button.svelte'
      import EntitiesLine from './Roles/EntitiesLine.svelte'
      import Tag from './Tag.svelte'
      import { authorAggregation, entityAggregation, getDateTime, roleAggregation } from './ts/Program'
      import { getMetaContext } from '../metatags/ts/MetaContext.svelte'
      import { openLink } from './ts/utils'

      const locale = getLocaleContext()
      const meta = getMetaContext()

      let { item, catalogueOnly = false } = $props()

      let { catalogue } = $derived(item)

      function setMeta() {
            meta.setMeta({
                  title: locale.ŧ({ default: catalogue.title_cs, en: catalogue.title_en }),
                  imageUrl: catalogue.image?.sizes?.medium?.url ?? catalogue.image?.url,
                  imageAlt: catalogue.image?.alt,
            })
      }

      $effect(() => {
            item
            untrack(() => {
                  setMeta()
            })
      })

      setMeta()
</script>

{#if item}
      <div class="w-full flex flex-col gap-4">
            <div class="relative">
                  <div class="w-full aspect-[3/2] overflow-hidden rounded-2xl shadow-md">
                        <ImageElement image={item.image ?? catalogue.image ?? null} class="object-cover h-full w-full"></ImageElement>
                  </div>
                  <!--<Gafa></Gafa>-->
            </div>

            <div class="h-full">
                  <div class=" flex min-h-24 md:items-center flex-col md:flex-row gap-4">
                        <div>
                              {#if !catalogueOnly}
                                    <div class="flex flex-col md:flex-row font-['nunito-sans'] gap-4 text-sm text-[#414141]">
                                          <div class="text-base">
                                                <span class="uppercase">{getDateTime(item.datetime, item.runtime ?? 0, locale.locale)}</span>
                                                | {item.venue?.title ?? ''}
                                                {#if catalogue.type.length > 0}
                                                      <span class="">
                                                            |
                                                            {catalogue.type.map((t: { type: string }) => t.type).join(', ') ?? ''}
                                                      </span>
                                                {/if}
                                          </div>
                                    </div>
                              {/if}
                              <div>
                                    <!--<p>{@html entityAggregation(catalogue?.author)}</p>-->
                                    <EntitiesLine entities={catalogue?.author}></EntitiesLine>
                                    <h1 class="block text-2xl text-accent">{locale.locale == 'cs' ? catalogue.title_cs : catalogue.title_en}</h1>
                                    <!--<p>{@html entityAggregation(catalogue.theater)}</p>-->
                                    <EntitiesLine entities={catalogue?.theater}></EntitiesLine>
                              </div>
                              <div class="flex gap-1 mt-1 flex-wrap">
                                    {#each catalogue?.type as type, i (i)}
                                          <Tag>{type.type}</Tag>
                                    {/each}

                                    {#each catalogue?.tags as tag, i (i)}
                                          <Tag>{tag.tag}</Tag>
                                    {/each}
                              </div>
                        </div>
                        {#if !catalogueOnly}
                              {#if item.placeholderTicketsLink && item.showPlaceholderTicketsLink}
                                    <div class=" mx-auto md:mx-[unset] md:ml-auto flex justify-center">
                                          <Button
                                                href={item.ticketsLink}
                                                onclick={async (ev) => {
                                                      ev.preventDefault()
                                                      ev.stopPropagation()
                                                }}
                                                type="button"
                                                variant="disabled"
                                                size="custom"
                                                class="w-full text-center"
                                                >{item.placeholderTicketsLink}
                                          </Button>
                                    </div>
                              {:else if item.ticketsLink && !item.hideTicketsLink && !item.showPlaceholderTicketsLink}
                                    <div class="mx-auto md:mx-[unset] md:ml-auto flex justify-center">
                                          <Button
                                                onclick={async (ev) => {
                                                      ev.preventDefault()
                                                      ev.stopPropagation()
                                                      openLink(item.ticketsLink)
                                                }}
                                                href={item.ticketsLink}
                                                type="link"
                                                variant="primary"
                                                size="custom"
                                                class="w-full text-center">{locale.ŧ({ default: 'vstupenky', en: 'tickets' })}</Button>
                                    </div>
                              {/if}
                        {/if}
                  </div>
            </div>
      </div>
{/if}

<style lang="postcss">
</style>
